<template>
  <div>
    <Modal
      :styles="{
        top: '20px',
        width: 'auto',
        maxWidth: '1024px',
        minHeight: '368px'
      }"
      :value="true"
      title="Stats Modal"
      :closable="false"
      :mask-closable="false"
      class="stats-modal"
    >
      <Spin fix v-if="loading">
        <Icon type="ios-loading" size="40" class="demo-spin-icon-load"></Icon>
        <div>{{ $t("global.loading") }}</div>
      </Spin>
      <div
        slot="header"
        class="d-flex justify-content-between align-items-center"
      >
        <div v-if="!editState" class="d-flex align-items-center">
          <h5 class="mr-2">{{ $t("club.table.stats") }} | {{ team.name }}</h5>
          <Button
            v-if="isSuper"
            target="_blank"
            type="dashed"
            @click="
              () => {
                this.editState = true;
              }
            "
          >
            <i class="bx bx-edit font-size-15 align-middle"></i>
          </Button>
        </div>
        <Input
          v-else
          v-model="teamCopy.name"
          :placeholder="$t('club.form.name')"
          type="text"
        >
          <Button
            slot="append"
            icon="md-checkmark-circle-outline"
            class="append-edit-btn"
            @click="editTeamName"
          ></Button>
        </Input>
        <div class="d-flex justify-content-center align-items-center gap-3">
          <Button
            v-if="isSuper"
            @click="deleteTeam"
            type="error"
            icon="md-trash"
            class="modal-close-btn ml-5"
            style="color: white !important;"
          ></Button>
          <Button
            @click="() => $emit('close')"
            type="text"
            icon="md-close"
            class="modal-close-btn ml-2"
          ></Button>
        </div>
      </div>
      <Alert v-if="serverError.length" type="error"> {{ serverError }} </Alert>
      <div class="table-special-div">
        <table
          v-if="!loading"
          class="table-stats table table-bordered dt-responsive table-striped nowrap w-100 ml-0"
        >
          <thead>
            <tr>
              <th class="first-table-head">
                {{ $t("user.table.name") }}/{{ $t("user.table.surname") }}
              </th>
              <th>{{ $t("competition.scored") }}</th>
              <template
                v-for="stage in competition.stages.filter(
                  stage => stage.category === category
                )"
              >
                <th :key="stage._id + Date.now()">{{ stage.name }}</th>
              </template>
            </tr>
          </thead>
          <tbody>
            <template v-for="player in players">
              <tr>
                <td>
                  <div
                    class="d-flex justify-content-between align-items-center"
                  >
                    <Tooltip placement="top-start" style="width: 170px;">
                      <span
                        class="text-overflow-style single-groups-clamp-text w-100"
                      >
                        <span v-if="player.jersey">{{ player.jersey }}.</span>
                        {{ player.firstName }} {{ player.secondName }}
                      </span>
                      <div slot="content">
                        <span v-if="player.jersey">{{ player.jersey }}.</span
                        >{{ player.firstName }} {{ player.secondName }}
                      </div>
                    </Tooltip>
                    <Button
                      v-if="isSuper"
                      @click="() => deletePlayer(player._id)"
                      type="text"
                      icon="md-close"
                      class="modal-close-btn"
                    />
                  </div>
                </td>
                <td>
                  {{ player.goals }}
                </td>
                <template
                  v-for="stage in competition.stages.filter(
                    stage => stage.category === category
                  )"
                >
                  <td :key="stage._id + Date.now()">
                    <span>{{
                      player[stage.name.replace(" ", "_") + "_Goals"]
                    }}</span>
                  </td>
                </template>
              </tr>
            </template>
          </tbody>
        </table>
      </div>

      <div slot="footer" class="text-center">
        <div
          v-if="isSuper"
          class="d-flex px-3 py-2 w-100 align-items-start justify-content-between"
        >
          <PlayerSelector
            :special="true"
            :licenseFilter="() => licenseFilter(licenses)"
            :checkIfCompetitionStarted="false"
            :checkMedicalControl="checkMedicalControl"
            :addPlayer="e => addPlayer(e)"
          />
          <Button
            @click="() => updatePlayersInTeam()"
            :loading="loading"
            type="success"
            style="min-width: 150px"
          >
            <b style="color: white;">{{ $t("global.save") }}</b>
          </Button>
          <!-- <ButtonGroup class="modal-footer-btn">
          <Button @click="handleSubmit('addDriverForm')" :loading="loading" type="success"
            style="min-width: 150px"><b>{{$t('global.save')}}</b></Button>
        </ButtonGroup> -->
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import PlayerSelector from "../../team/PlayerSelector.vue";

export default {
  props: ["team", "competition", "category"],
  components: { PlayerSelector },
  data() {
    return {
      serverError: [],
      players: [],
      loading: false,
      licenses: [],
      isSuper: false,
      editState: false,
      teamCopy: null,
      unavailablePlayers: []
    };
  },
  methods: {
    //TODO
    enableFor(arr) {
      console.log("this.$user.role", this.$user.data.role);
      if (!this.$user.data.role) return false;
      this.isSuper = arr.includes(this.$user.data.role[0]);
    },
    checkMedicalControl(license) {
      if (license.medical_Date < new Date().getFullYear()) {
        return true;
      }
      return false;
    },
    async deleteTeam() {
      try {
        this.$dialog
          .confirm(this.$t("global.confirmDelete"), {
            okText: this.$t("global.yes"),
            cancelText: this.$t("global.no")
          })
          .then(async _dialog => {
            const res = await this.$http.post("/team/delete", {
              _id: this.team._id
            });
            if (res.data) {
              this.$Message.success({
                content: this.$t("competition.team_deleted", {
                  team: res.data.team.name
                }),
                duration: 5,
                closable: true
              });
              this.$emit("close");
            }
          })
          .catch(error => {
            console.log(error);
            // this.$Message.error(`${error}`)
          });
      } catch (error) {
        this.$Message.error({
          content: error,
          duration: 5,
          closable: true
        });
      }
    },
    async editTeamName() {
      try {
        const res = await this.$http.post("/team/edit", this.teamCopy);
        console.log(res);
        if (res.data) {
          this.editState = false;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async updatePlayersInTeam() {
      this.loading = true;

      try {
        await this.$http.post("/team/players/update", {
          team_id: this.team._id,
          players: this.players
        });

        setTimeout(() => {
          this.loading = false;
          this.$Message.success(this.$t("global.saved"));
        }, 1500);
      } catch (error) {
        console.log(error);

        setTimeout(() => {
          this.loading = false;
          this.$Message.error(this.$t("Fail!"));
        }, 1500);
      }
    },
    addPlayer(e) {
      let neededPlayer = this.licenses.find(license => license._id === e);
      this.players.push(neededPlayer);
    },
    deletePlayer(e) {
      this.players = this.players.filter(player => player._id !== e);
    },
    async getPlayersOfClub() {
      try {
        const res = await this.$http.post("/license/list", {
          club: this.team.clubId._id
        });
        this.licenses = res.data;
      } catch (error) {
        console.log(error);
      }
    },
    async getClubTeams() {
      try {
        const res = await this.$http.post("/team/clublist", {
          // clubId: this.team.clubId._id,
          competition_id: this.competition._id,
          category: this.category
        });
        if (res.data.length) {
          let players = res.data.map(item => {
            return [...item.players];
          });
          this.unavailablePlayers = players.flat();
          console.log("unavailable players :>> ", players.flat());
        }
      } catch (error) {
        console.log(error);
      }
    },
    licenseFilter(players) {
      const currentYear = new Date().getFullYear();
      const currentDate = this.team.category.name.includes("Senior")
        ? new Date(currentYear, 11, 31)
        : new Date();
      return players
        .filter(
          athlete =>
            !this.unavailablePlayers.some(
              ({ player }) => player === athlete._id
            )
        )
        .filter(
          athlete => !this.players.some(player => player._id === athlete._id)
        )
        .filter(athlete => {
          let birthDate = new Date(athlete.birthday);
          let age = currentDate.getFullYear() - birthDate.getFullYear();
          let monthDiff = currentDate.getMonth() - birthDate.getMonth();
          if (
            (monthDiff < 0 ||
              (monthDiff === 0 &&
                currentDate.getDate() < birthDate.getDate())) &&
            this.team.category.name.includes("Senior")
          ) {
            age--;
          }
          if (this.team.category.name.includes("Senior")) {
            this.team.category.min_age = 16;
          }
          return (
            age >= this.team.category.min_age - 1 &&
            age <=
              (athlete.sex === 2
                ? this.team.category.max_age + 2
                : this.team.category.max_age)
          );
        })
        .filter(athlete =>
          athlete.sex === 1 ||
          (athlete.sex === 2 &&
            (this.team.category.name.includes("Senior") ||
              this.team.category.name.includes("U-18")))
            ? athlete.sex === this.team.category.gender
            : true
        )
        .sort(athlete => (this.checkMedicalControl(athlete) ? -1 : 1));
    },
    async getGoalsByPlayer() {
      try {
        this.loading = true;
        const res = await this.$http.post("/team/players", {
          teamId: this.team._id
        });
        if (res.data.length) {
          let players = res.data.map(id => {
            return {
              goals: id.totalPoints,
              jersey: id.jerseyNumber,
              ...id.playerId
            };
          });
          this.players = players;
          console.log("players :>> ", players);
          await this.getGoalsByStages();
        }
        if (res.data.length !== this.team.players.length)
          await this.getPlayersOfTeam();

        setTimeout(() => {
          this.loading = false;
        }, 1500);
      } catch (error) {
        console.log(error);
      }
    },
    async getPlayersOfTeam() {
      try {
        this.loading = true;
        const res = await this.$http.post("/team/find", { _id: this.team._id });
        if (res.data && res.data.players.length) {
          let players = res.data.players
            .filter(
              item =>
                !this.players.some(player => player._id === item.player._id)
            )
            .map(id => {
              return { jersey: id.jersey_number, ...id.player };
            });
          this.players.push(...players);
        }

        setTimeout(() => {
          this.loading = false;
        }, 1500);
      } catch (error) {
        console.log(error);
      }
    },
    async getGoalsByStages() {
      this.loading = true;
      for (let i = 0; i < this.competition.stages.length; i++) {
        const element = this.competition.stages[i];
        try {
          const res = await this.$http.post("/team/stages", {
            teamId: this.team._id,
            stageId: element._id
          });
          for (let k = 0; k < this.players.length; k++) {
            if (
              res.data.find(data => data.playerId._id === this.players[k]._id)
            )
              this.players[k][
                element.name.replace(" ", "_") + "_Goals"
              ] = res.data.find(
                data => data.playerId._id === this.players[k]._id
              ).totalPoints;
            else this.players[k][element.name.replace(" ", "_") + "_Goals"] = 0;
          }
        } catch (error) {
          console.log(error);
        }
      }

      setTimeout(() => {
        this.loading = false;
      }, 1500);
    }
  },
  async mounted() {
    await this.getGoalsByPlayer();
    await this.getPlayersOfClub();
    await this.getClubTeams();
    this.enableFor(["super"]);
    console.log(this.team);
    if (this.team) {
      this.teamCopy = this.team;
    }
  }
};
</script>

<style scoped>
table.table-stats {
  border-radius: 0.25em;
  border-collapse: collapse;
}

.disabled td {
  color: #495057;
}

.table-stats tbody tr {
  transition: background 0.25s ease;
}

.stats-modal :global(.ivu-modal) {
  width: max-content !important;
}
.stats-modal :global(.ivu-modal-content) {
  width: max-content !important;
  min-width: 368px;
  min-height: 368px;
  max-height: 90vh;
  height: auto;
  /* overflow-y: scroll; */
}
.stats-modal :global(.ivu-modal-body) {
  max-height: 82vh;
  overflow-y: scroll;
}
.stats-modal .table-striped tbody tr:nth-of-type(odd):hover,
.table-stats tbody tr:hover {
  background: #e4e4e4 !important;
}

.stats-modal :global(.ivu-modal-header) {
  padding-bottom: 0;
}

.stats-modal :global(.ivu-modal-header),
.stats-modal :global(.ivu-modal-footer) {
  border: none;
}

.stats-modal :global(.ivu-modal-footer) {
  padding: 0;
}

/* .stats-modal :global(.ivu-input):focus {
  box-shadow: none !important;
  border-color: #dcdee2;
}
.stats-modal :global(.ivu-input):hover {
  box-shadow: none !important;
  border-color: #dcdee2;
} */

.stats-modal :global(.ivu-input-group-append) {
  padding: 0;
  background: #28a746;
  color: white;
  border-top: 1px solid #dcdee2;
  border-bottom: 1px solid #dcdee2;
  border-right: 1px solid #dcdee2;

}

.stats-modal .append-edit-btn {
  padding: 0;
  margin: 0;
  color: white !important;
  height: 30px;
  width: 32px;
}

.stats-modal .append-edit-btn:hover{
  color: #f2f2f3 !important;
}

.stats-modal :global(.ivu-modal-content) {
  /* background: #454751; */
  /* border: 1px solid #272727; */
}

.stats-modal h5,
.stats-modal table td,
.stats-modal table th,
.stats-modal button {
  color: #495057 !important;
}

.stats-modal button:hover {
  filter: brightness(0.8);
  color: #495057 !important;
}

.stats-modal button {
  /* background: #454751 !important; */
}

.stats-modal :global(.ivu-modal-mask) {
  opacity: 0.8 !important;
  /* background-color: #000; */
}

.stats-modal .table-striped tbody tr:nth-of-type(odd) {
  /* background: #3d3f48 !important; */
}

.stats-modal table {
  font-size: small;
  /* table-layout: fixed; */
}

.stats-modal table td,
.stats-modal table th {
  padding: 0.35rem;
  /* border-color: #333333 !important; */
  vertical-align: middle;
}

@media only screen and (max-width: 575.98px) {
  .stats-modal :global(.ivu-modal) {
    margin: 10px auto !important;
    width: 100% !important;
  }
  .stats-modal :global(.ivu-tooltip) {
    width: 110px !important;
    min-width: 110px !important;
  }
}

@media only screen and (max-width: 767.98px) {
  .stats-modal :global(.ivu-modal-header) {
    padding: 10px 10px 0;
  }

  .stats-modal :global(.ivu-modal-body) {
    padding: 10px;
    overflow-x: hidden;
  }

  .stats-modal .table-stats {
    margin-bottom: 0;
  }

  .table-special-div {
    overflow-x: scroll;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/competitions/schemes/StatsModal.vue